export { default as DownloadLifestyleSeparatelyButton } from './DownloadLifestyleSeparatelyButton';
